// Notificaciones — decisión de silenciado de la alarma compartida.
//
// El reproductor (`Audio`) en NotificationsContext es ÚNICO y compartido por todas las
// notificaciones. Si al remover una notificación se detiene el sonido de forma incondicional,
// se apaga también la alarma de cualquier otra notificación que aún deba sonar (p. ej. "Ignorar"
// un pedido de otra sucursal mientras suena un pedido propio).
//
// Regla: detener la alarma compartida SOLO si, tras la remoción, no queda ninguna notificación
// activa que siga sonando (es decir, no muteada). Una notificación con `mute: true` nunca arrancó
// el sonido, así que no cuenta para mantenerlo vivo.
export const shouldStopSharedAlarm = (remainingNotifications: { mute?: boolean }[]): boolean =>
  !remainingNotifications.some((n) => !n.mute);

export default shouldStopSharedAlarm;
